import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import { T as Typography } from './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import './index-f96168ba.js';
import Link from './Link.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border:", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return "".concat(theme.components.alert.borders.size, " solid ").concat(theme.components.alert.colors.borders[variant]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.alert.borders.radius;
});
var spaces = css(["padding:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.alert.spaces.padding;
});
var sizes = css(["width:", ";height:", ";line-height:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.alert.sizes.width;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.alert.sizes.height;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.alert.sizes.lineHeight;
});
var colors = css(["background-color:", ";", ",", "{color:", ";}"], function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return theme.components.alert.colors.background[variant];
}, Typography, Link, function (_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant;
  return theme.components.alert.colors.text[variant];
});
var StyledDiv = styled('div')(_templateObject(), borders, spaces, sizes, colors);

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * An alert component.
 *
 */

var Alert = function Alert(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["children", "variant"]);

  return React.createElement(StyledDiv, _extends({
    variant: variant
  }, rest), children);
};

Alert.defaultProps = {
  variant: 'success'
};
Alert.propTypes = {
  /**
   * Content of the Alert.
   */
  children: PropTypes.node.isRequired,

  /**
   * Type of alert.
   */
  variant: PropTypes.oneOf(['success', 'error', 'info', 'warning'])
};
/** @component */

var index = styled(Alert)(_templateObject$1());

export default index;
